export default "__VITE_ASSET__8b1d67f2__"